import { useEffect, useState } from 'react';
import { api } from '../api/client';

const STATUS_LABELS = {
  EN_COURS: ['navy',  'En cours'],
  RENDU:    ['green', 'Rendu'],
};

function daysLate(r) {
  const ref = r.status === 'RENDU' && r.returnDate ? new Date(r.returnDate) : new Date();
  const diff = Math.floor((ref - new Date(r.dueDate)) / 86400000);
  return diff > 0 ? diff : 0;
}

export default function LibraryHistorique() {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    api.get('/library/history').then((data) => setRows(data || [])).catch((e) => setError(e.message));
  }, []);

  const filtered = rows.filter((r) => {
    const q = search.toLowerCase();
    const matchSearch = !q || `${r.lastName || ''} ${r.firstName || ''} ${r.title || ''} ${r.matricule || ''}`.toLowerCase().includes(q);
    const matchStatus = !statusFilter || r.status === statusFilter;
    return matchSearch && matchStatus;
  });

  return (
    <div className="panel">
      <div className="panel-head">
        <h2>Historique des mouvements</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <input placeholder="Nom, ouvrage…" value={search} onChange={(e) => setSearch(e.target.value)} style={{ width: 200 }} />
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} style={{ width: 140 }}>
            <option value="">Tous</option>
            <option value="EN_COURS">En cours</option>
            <option value="RENDU">Rendu</option>
          </select>
        </div>
      </div>
      <div className="panel-body">
        {error && <div className="form-error">{error}</div>}
        {filtered.length === 0 ? <div className="empty">Aucun mouvement.</div> : (
          <div className="table-wrap"><table>
            <thead>
              <tr>
                <th>Emprunteur</th><th>Ouvrage</th><th>Code</th>
                <th>Emprunt</th><th>Retour prévu</th><th>Retour effectif</th>
                <th>Jours retard</th><th>Statut</th>
              </tr>
            </thead>
            <tbody>{filtered.map((r) => {
              const late = daysLate(r);
              const [bc, bl] = STATUS_LABELS[r.status] || ['gray', r.status || '?'];
              return (
                <tr key={r.id} style={late > 0 ? { background: 'var(--danger-soft)' } : undefined}>
                  <td>
                    <b>{r.lastName} {r.firstName}</b>
                    {r.matricule && <><br /><small className="mono" style={{ color: 'var(--muted)' }}>{r.matricule}</small></>}
                  </td>
                  <td><b>{r.title}</b>{r.author && <><br /><small style={{ color: 'var(--muted)' }}>{r.author}</small></>}</td>
                  <td className="mono">{r.code || '—'}</td>
                  <td className="mono">{r.loanDate ? new Date(r.loanDate).toLocaleDateString('fr-FR') : '—'}</td>
                  <td className="mono">{r.dueDate ? new Date(r.dueDate).toLocaleDateString('fr-FR') : '—'}</td>
                  <td className="mono">{r.returnDate ? new Date(r.returnDate).toLocaleDateString('fr-FR') : '—'}</td>
                  <td className="num">
                    {late > 0
                      ? <span className="badge red">{late}j</span>
                      : <span>0</span>}
                  </td>
                  <td><span className={`badge ${bc}`}>{bl}</span></td>
                </tr>
              );
            })}</tbody>
          </table></div>
        )}
        <div style={{ marginTop: 8, color: 'var(--muted)', fontSize: '0.85rem' }}>
          {filtered.length} mouvement(s) affiché(s)
        </div>
      </div>
    </div>
  );
}
